export default function parseBoolean(value: unknown): boolean {
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true' || value === '1';
  }
  if (typeof value !== 'boolean') {
    return Boolean(value);
  }
  return value;
}
